import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { OnOffSwitch } from "@similarweb/ui-components";

export const StyledOnOffSwitch = styled(OnOffSwitch).attrs<{ "data-automation"?: string }>((props) => ({
    "data-automation": "on-off-switch",
}))`
    margin-right: 12px;
    margin-top: 1px;
`;

export const StyledFieldsCount = styled.div`
    position: absolute;
    top: 20px;
    right: 17px;
    ${setFontVariant("listItem3", colorsPalettes.carbon["500"])}
`;
